import { Typography } from '@mui/material';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import i18n, { default as i18next } from '../../i18n';
import { appEnvironment } from '../../common/environment';
import {
  getAcceptableUsePolicyURI,
  getMemberTermsURI,
  getPrivacyNoticeURI,
} from '../../common/legalConstants';

export default function TermsAndPrivacyNotice({
  className,
}: {
  className?: string;
}) {
  const { t } = useTranslation();
  const isJa = (i18n.resolvedLanguage ?? i18n.language)?.startsWith('ja');

  const uriOptions = useMemo(
    () => ({ isJa, language: i18next.language }),
    [isJa]
  );

  const memberTermsURI = useMemo(
    () => getMemberTermsURI(uriOptions),
    [uriOptions]
  );
  const acceptableUsePolicyURI = useMemo(
    () => getAcceptableUsePolicyURI(uriOptions),
    [uriOptions]
  );
  const privacyNoticeURI = useMemo(
    () => getPrivacyNoticeURI(uriOptions),
    [uriOptions]
  );

  const { primary } = appEnvironment.theme.colours;

  return (
    <Typography
      variant="body2"
      className={`text-center ${className ?? ''}`}
      sx={{
        lineHeight: '18px',
        color: '#757D87',
        fontSize: '12px',
      }}
    >
      {t('byCreatingAccount', 'By creating an account, you accept the')}{' '}
      <a
        target="_blank"
        rel="noopener noreferrer"
        href={memberTermsURI}
        className="underline font-medium"
        style={{ color: primary }}
      >
        {t('memberTerms', 'Member Terms')}
      </a>{' '}
      {t('and', 'and')}{' '}
      <a
        target="_blank"
        rel="noopener noreferrer"
        href={acceptableUsePolicyURI}
        className="underline font-medium"
        style={{ color: primary }}
      >
        {t('acceptableUsePolicy', 'Acceptable Use Policy')}
      </a>
      . {t('seeOur', 'See our')}{' '}
      <a
        target="_blank"
        rel="noopener noreferrer"
        href={privacyNoticeURI}
        className="underline font-medium"
        style={{ color: primary }}
      >
        {t('privacyNotice', 'Privacy Notice')}
      </a>
    </Typography>
  );
}
